var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEbookIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.5543V3.50179C16.5 2.60179 15.765 1.93429 14.8725 2.00929H14.8275C13.2525 2.14429 10.86 2.94679 9.525 3.78679L9.3975 3.86929C9.18 4.00429 8.82 4.00429 8.6025 3.86929L8.415 3.75679C7.08 2.92429 4.695 2.12929 3.12 2.00179C2.2275 1.92679 1.5 2.60179 1.5 3.49429V12.5543C1.5 13.2743 2.085 13.9493 2.805 14.0393L3.0225 14.0693C4.65 14.2868 7.1625 15.1118 8.6025 15.8993L8.6325 15.9143C8.835 16.0268 9.1575 16.0268 9.3525 15.9143C10.7925 15.1193 13.3125 14.2868 14.9475 14.0693L15.195 14.0393C15.915 13.9493 16.5 13.2743 16.5 12.5543Z",
    stroke: "#00BB8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.11719V15.3672",
    stroke: "#00BB8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 6.36719H4.125",
    stroke: "#00BB8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 8.61719H4.125",
    stroke: "#00BB8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbookIcon);
export default __webpack_public_path__ + "static/media/ebookIcon.d0a895e5680f79b4b4bfeccf50a40efc.svg";
export { ForwardRef as ReactComponent };